<script module>
  export { default as layout } from '@layouts/authentication-layout.svelte'
</script>

<svelte:head>
  <title>Confirm Your New Email</title>
</svelte:head>

<script>
  import Button from '@components/buttons/button.svelte'
  import { Link, page, useForm } from '@inertiajs/svelte'
  import Logo from '@assets/images/altruist-vertical-logo.svg'

  let token = $derived($page.props.token)
  let pendingEmail = $derived($page.props.pending_email)

  const form = useForm({})

  function handleSubmit(e) {
    e.preventDefault()
    $form.post(`/email_change/${token}/confirm`)
  }
</script>

<div class="flex min-h-0 flex-1 flex-col">
  <div class="flex flex-1 flex-col justify-center">
    <div class="flex justify-center mb-10">
      <img src={Logo} alt="Altruist" class="w-32" />
    </div>

    <div class="auth-form text-center">
      <h1 class="text-3xl font-serif text-gray-700 mb-4">Confirm your new email</h1>
      <p class="text-gray-600 mb-2">
        Confirm this change to update the email address on your account.
      </p>
      {#if pendingEmail}
        <p class="text-gray-700 font-medium mb-8">{pendingEmail}</p>
      {/if}

      <form id="email-change-confirm-form" on:submit={handleSubmit}>
        <Button
          type="submit"
          variant="bold"
          size="lg"
          class="w-full h-12 border-none hover:border-none justify-center"
          text="Confirm new email address"
          loading={$form.processing}
        />
      </form>
    </div>
  </div>

  <div class="pt-4 text-center text-sm text-gray-700">
    <Link href="/session/new" class="text-gray-700 hover:text-primary-700 no-underline border-b-2 border-primary-500">Back to sign in</Link>
  </div>
</div>
